module.exports = __webpack_public_path__ + "static/android-chrome-512x512-3772e2acde9a7d923cb496220d3c3efe.png";